export default __webpack_public_path__ + "static/media/productimage21.252a1e98.png";